jQuery(document).ready(function ($) {
  function headerScrollHandler() {
    let header = $('#site-header');
    const windowWidth = $(window).width();

    if(windowWidth > 991) {
      if ($('.header-wrapper').length === 0) {
        $(".header-wrapp").wrapAll("<div class='header-wrapper' />");
      }
      header = $('.header-wrapper');
    } else {
      if ($('.header-wrapper').length !== 0) {
        $(".header-wrapper").children().unwrap();
      }
    }

    if (window.scrollY > 0) {
      header.addClass('site-header--sticky');
    } else {
      header.removeClass('site-header--sticky');
    }
  }

  headerScrollHandler();
  $(document).on('scroll', headerScrollHandler);

  // Top banner reveal on scroll-up, hide on scroll-down.
  let lastScrollY = window.scrollY;

  function topBannerScrollHandler() {
    const topBanner = $('.onereach-topbanner');
    if (topBanner.length === 0) {
      return;
    }

    const currentScrollY = window.scrollY;
    const bannerHeight = topBanner.outerHeight();
    const stickyHeader = $('.header-wrapper').length !== 0 ? $('.header-wrapper') : $('#site-header');

    // Disable the reveal-on-scroll effect on small mobile screens.
    if ($(window).width() <= 576) {
      topBanner.removeClass('onereach-topbanner--hidden');
      stickyHeader.css('top', '');
      lastScrollY = currentScrollY;
      return;
    }

    // Banner is visible near the top of the page or when scrolling up,
    // and hidden while scrolling down.
    let showBanner;
    if (currentScrollY <= bannerHeight) {
      showBanner = true;
    } else if (currentScrollY > lastScrollY) {
      showBanner = false;
    } else {
      showBanner = true;
    }

    if (showBanner) {
      // Reveal the banner and push the header below it so they never overlap.
      topBanner.removeClass('onereach-topbanner--hidden');
      stickyHeader.css('top', bannerHeight + 'px');
    } else {
      // Hide the banner and let the header stick to the very top on its own.
      topBanner.addClass('onereach-topbanner--hidden');
      stickyHeader.css('top', '');
    }

    lastScrollY = currentScrollY;
  }

  topBannerScrollHandler();
  $(document).on('scroll', topBannerScrollHandler);

  // Double nav
  const doubleNav = $('.site-header .header-second-nav');
  if(doubleNav.length !== 0) {
    $('.site-header .header-second-nav li:first-child').append(`<span class="icon"><svg width="10" height="6" viewBox="0 0 10 6" fill="none"><path d="M1 1L5 5L9 1" stroke="#E5E5E5" stroke-linecap="square"/></svg></span>`);
    $('.site-header .header-second-nav li:not(:first-child)').wrapAll('<div class="header-second-nav__wrapper"></div>');

    $('.site-header .header-second-nav ul > li:first-child').on('click', function (e) {
      e.preventDefault();
      $(this).toggleClass('active');
      $(this).closest('.site-header').find('.header-second-nav__wrapper').toggleClass('active');

      return false;
    });
  }

  $('.or-megamenu .menu-item-mega > a[href="#"]').on('click', function () {
    const parentItem = $(this).parent('.menu-item-mega');
    $('.menu-item-mega').not(parentItem).removeClass('active');
    parentItem.toggleClass('active');
    return false;
  });

  $('body').on('click', function (e) {
    if (!$(e.target).closest('.or-megamenu').length) {
      $('.menu-item-mega').removeClass('active');
    }
  });

  function adjustMegaMenuPosition() {
    $('.or-megamenu__columns-1, .small-width').each(function () {
      const leftPos = $(this).position().left;
      const menuWrapper = $(this).find('.or-megamenu__wrapper');
      menuWrapper.css('left', `${leftPos}px`);
    });

    $('.or-megamenu__wrapper').each(function () {
      const windowHeight = $(window).height();
      const siteHeaderHeight = $('#site-header').outerHeight();
      const availableHeight = windowHeight - siteHeaderHeight - 50;

      $(this).css('max-height', `${availableHeight}px`);
    });
  }

  adjustMegaMenuPosition();
  $(window).on('resize', adjustMegaMenuPosition);
});